import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Form,
  Nav,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import moment from "moment";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import '../../../views/dashboard/styles.css'
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { MdOutlineDone } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { getToken } from "../../../utils/auth";
// import ShareToFeedPopup from "./ShareToFeedPopupEvent";

const EventProfile = (userUid) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    clearData();
  }
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const { t, i18n } = useTranslation();
  const [imagePreview, setImagePreview] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [feedData, setFeedData] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });

  // useEffect(() => {
  //   console.log("formData", formData);
  // }, [formData]);

  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") {
      const file = e.target.files[0];
      if (file) {
        if (file.size > 1 * 1024 * 1024) {
          toast.error("File size must not exceed 1MB");
          return;
        }
          setFormData({ ...formData, [name]: file });
  
        const preview = URL.createObjectURL(file);
        setImagePreview([preview]);
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };

    const [eventTypeData, setEventTypeData] = useState("local");

    const handleEventTypeChange = (e) => {
      setEventTypeData(e.target.value);
    };

  const [isEditing, setIsEditing] = useState(false);
const [eventId, setEventId] = useState(null);


const handleEditClick = (eventData) => {
  setIsEditing(true);
  setEventId(eventData._id);
  setDescription(eventData?.description || '');

  const formatDateTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  };

  setFormData({
    title: eventData?.title || '',
    image: eventData?.image || '',
    startDate: formatDateTime(eventData?.startDate),
    endDate: formatDateTime(eventData?.endDate),
    location: eventData?.location || '',
    note: eventData?.note || '',
    category: eventData?.category || '',
  });
setCategorypost(eventData?.category || '');
setEventTypeData(eventData?.eventType || '')
  setShow(true);
};

const clearData = ()=> {
  setFormData({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });
  setEventTypeData('local')

  setIsEditing(false)
setEventId(null)
  setImagePreview(null)
  setDescription("");
}
  
  const handleEvent = async () => {
    if (
      !formData.title ||
      !description ||
      !formData.location ||
      // !formData.image ||
      !formData.startDate ||
      !formData.endDate ||
      !categorypost ||
      !eventTypeData
    ) {
      toast.error("All fields are required");
      return;
    }

    try {
      const formDataObject = new FormData();
      formDataObject.append("title", formData.title);
      formDataObject.append("description", description);
      formDataObject.append("image", formData.image);
      formDataObject.append("startDate", formData.startDate);
      formDataObject.append("endDate", formData.endDate);
      formDataObject.append("location", formData.location);
      formDataObject.append("note", formData.note);
      formDataObject.append("category", categorypost);
      formDataObject.append("eventType", eventTypeData);

      const token = getToken();

      const url = isEditing 
      ? `${process.env.REACT_APP_URL}/api/event/${eventId}` 
      : `${process.env.REACT_APP_URL}/api/event`;
 
    const method = isEditing ? "put" : "post";

    const response = await axios({
      method,
      url,
      data: formDataObject,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    setPage(1)
    toast.success(`Event ${isEditing ? "updated" : "created"} successfully`);
      handleAllPost(true);
      clearData();
    } catch (error) {
      toast.error(error?.response?.data?.message || `Failed ${isEditing ? "updating" : "creating"} event`);
      console.log("Failed creating Event", error);
    } finally {
      setShow(false);
    }
  };
  const [deleteId, setDeleteId] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const handleCloseDelete = () => {
    setShowDelete(false);
    setDeleteId("");}

  const handleShowDelete = (contactid) => {
    setDeleteId(contactid);
    setShowDelete(true);
  };

  const handleDeletePost = async () => {
    if (!deleteId) {
      toast.error("Please try later");
    }
    try {
      const token = getToken();
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/api/event/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPage(1);
      handleAllPost(true);
      setDeleteId("");
      handleCloseDelete();
      // console.log("Post Deleted Successfully");
      toast.success("Post deleted successfully");
    } catch (error) {
      console.error("Failed ", error);
      toast.error(error?.response?.data?.message || "Failed to delete Contact");
    }
  };

  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

const [eventType, setEventType] = useState("");
  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      let url =  `${process.env.REACT_APP_URL}/api/event/all?userId=${userUid?.userUid}&page=${page}&limit=5`
      // if(eventType)
      // {
      //   url += `&searchFor=${eventType}`
      // }
      const response = await axios.get(
        url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (updateData) {
        setPost(response.data.data.allEvents);
      } else {
        setPost((prevPost) => [...prevPost, ...response.data.data.allEvents]);
      }
      setHasMore(response.data.data.allEvents.length > 0);
    } catch (error) {
      console.log("Failed Fetching Event", error);
    }
  };

  useEffect(() => {
    handleAllPost();
  }, [page]);

  useEffect(() => {
    handleAllPost(true);
  }, [eventType]);

 
  const renderDescription = (data, index) => {
    const description = data?.description;
    const threshold = 180;

    if (description && description.length > threshold) {
      if (expandedRows[index]) {
        return (
          <div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
              }}
            >
              {t('show_less')}
            </button>
          </div>
        );
      } else {
        return (
          <div>
            <div
              style={{ display: "inline" }}
              dangerouslySetInnerHTML={{
                __html: `${description.slice(0, threshold)}...`,
              }}
            />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "inline",
              }}
            >
              {t('show_more')}
            </button>
          </div>
        );
      }
    } else {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }
  };
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const date = new Date();
      const dayOfMonth = date.getDate();
      setCurrentDate(dayOfMonth);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const [expandedPosts, setExpandedPosts] = useState(
    Array(post.length).fill(false)
  );

  const toggleExpanded = (index) => {
    const updatedExpandedPosts = [...expandedPosts];
    updatedExpandedPosts[index] = !updatedExpandedPosts[index];
    setExpandedPosts(updatedExpandedPosts);
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportId, setReportId] = useState("");
  const handleReportClick = (reqid) => {
    setReportId(reqid);
    setReportModalOpen(true);
  };

  const closeReportModal = () => {
    setReportModalOpen(false);
  };
  const handleReport = async () => {
    if (!reportDescription) {
      toast.error("Report issue is required");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/report`,
        {
          reportFor: "event",
          issueDescription: reportDescription,
          userId: "",
          postId: "",
          eventId: reportId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeReportModal();
      setReportId("");
      setReportDescription("");
      toast.success(response.data.message);
    } catch (error) {
      setReportId("");
      setReportDescription("");
      toast.error(error?.response?.data?.message || "Failed Reporting Post");
      console.log("Failed SaviReportingng Posts", error);
    }
  };

  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const handleGoingStatus = async (eventid, status) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/event/going-status/${eventid}`,
        {
          goingStatus: status,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setPage(1)
      handleAllPost(true);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Failed Chnaging Status");
      toast.error(error?.response?.data?.message || "Failed Updating Status");
    }
  };
  const endDateRef = useRef(null);

  const navigateprofile = (id) => {
    navigate(`/userprofile/${id}`);
  };

  const handleCopyUrl = (postId) => {
    const url = `${process.env.REACT_APP_URL_POST}/event/${postId}`;
    navigator.clipboard.writeText(url).then(() => {
    //   alert('URL copied to clipboard');
    toast.success("URL Copied")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  };

  const handlePostFeed = (data) => {
    setShowPopup(true)
    setFeedData(data)
  }

  const downloadQR = async () => {
    if (!qrImageUrl?.qrCodeUrl || !qrImageUrl?.eventUID) return;
  
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // Prevent CORS issues
    image.src = qrImageUrl.qrCodeUrl;
  
    image.onload = () => {
      const padding = 70; // Extra space for UID + website + margin
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
  
      canvas.width = image.width;
      canvas.height = image.height + padding;
  
      // Set white background
      ctx.fillStyle = "white";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
  
      // Draw the QR image
      ctx.drawImage(image, 0, 0);
  
      // UID: Bold and 18px
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.font = "bold 18px Arial";
      ctx.fillText(qrImageUrl.eventUID, canvas.width / 2, image.height + 20);
  
      // Website: Normal and 10px
      ctx.font = "normal 10px Arial";
      ctx.fillText("www.dirido.com", canvas.width / 2, image.height + 40);
  
      // Create and trigger download
      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = `QR_${qrImageUrl.eventUID}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  };

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
        <>
          <Col lg={12} className="">
                 
            <InfiniteScroll
              dataLength={post.length}
              next={() => setPage((page) => page + 1)}
              hasMore={hasMore}
              loader={
                <div className="col-sm-12 text-center">
                  <img
                    src={loader}
                    alt="loader"
                    style={{ height: "100px" }}
                  />
                </div>
              }
              endMessage={<p className="text-center">No more events</p>}
            >
              {post?.length === 0 ? (
  <div style={{ width: '100%', textAlign: 'center' }}>
                  <img src="/noevent.png" alt="No Event" style={{ width: '100%', height: 'auto' }} />

                  </div>
              ) : (
                // {(
                  post?.map((data, index) => (
                  <Col sm={12} key={index} style={{ borderRadius:"5px", boxShadow: "0px -2px 4px rgba(0, 0, 0, 0.05), 2px 0px 6px rgba(0, 0, 0, 0.1), -2px 0px 6px rgba(0, 0, 0, 0.1)", // top, left, right
                  }}>
                    <Card className=" card-block card-stretch card-height" >
                      <Card.Body>
                        <div className="user-post-data">
                          <div className="d-flex justify-content-between">
                            <div className="me-3">
                              <img
                                className="rounded-circle img-fluid"
                                src="/calender.webp"
                                style={{ width: "55px" }}
                                alt=""
                              />
                              <div
                                style={{
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  marginTop: "-75%",
                                  display: "flex",
                                  color: "rgb(58,51,61)",
                                }}
                              >
                                {moment(
                                  data?.startDate ? data?.startDate : "1"
                                ).format("D")}
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h5 className="mb-0 d-inline-block">
                                    {data?.title}
                                  </h5>
                                  <p
                                    className="mb-0 text-primary"
                                    style={{ color: "black" }}
                                  >
                                    {data?.location}
                                  </p>
                                </div>
                                <div
                                  className="card-post-toolbar"
                                  style={{ display: "flex" }}
                                >
                                  {data?.qrCodeUrl ? (
                                    <div>
                                      <img
                                        src={data?.qrCodeUrl}
                                        onClick={() =>
                                          handleQrClick(data)
                                        }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "20px",
                          }}
                        >
                          <div className="containergrid">
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('start_date')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate).format(
                                  "MMM D, YYYY"
                                )}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('startTime')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('end_date')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate).format("MMM D, YYYY")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                {t('endTime')}
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#ececec",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "20px",
                          }}
                        >
                          <div style={{ flex: "1", marginRight: "10px" }}>
                            <strong
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigateprofile(data?.userId?._id)
                              }
                            >
                              {data?.userId?.firstName
                                ? data?.userId?.firstName
                                : "John"}
                            </strong>{" "}
                            {t('createdEvent')}
                          </div>
                          <div>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "going")
                              }
                            >
                              {t('going')} - {data?.goingStatusCount?.goingCount}
                            </button>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "maybe")
                              }
                            >
                              {t('maybe')} - {data?.goingStatusCount?.maybeCount}
                            </button>
                            <button
                              style={{
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "not-going")
                              }
                            >
                              {t('cantGo')} -{" "}
                              {data?.goingStatusCount?.notGoingCount}
                            </button>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              color: "red",
                            }}
                          >
                            {data?.note ? (
                              <div>{t('note')}: {data?.note}</div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                          {/* {expandedPosts[index] && ( */}
                            <>
                              <div className="mt-3">
                                <p>{renderDescription(data, index)}</p>
                              </div>
                              {data?.image && (
                              <div className="user-post">
                                <img
                                  src={data?.image}
                                  alt="post1"
                                  className="img-fluid rounded w-100"
                                />
                              </div>)}
                            </>
                          {/* )} */}
                          {/* <div
                            onClick={() => toggleExpanded(index)}
                            className="text-primary"
                            style={{
                              border: "none",
                              borderRadius: "10px",
                              textAlign: "center",
                              padding: "10px 5px 0px 5px",
                            }}
                          >
                            {expandedPosts[index] ? (
                              <div>
                                Hide Details <IoIosArrowUp />
                              </div>
                            ) : (
                              <div>
                                View Details <IoIosArrowDown />
                              </div>
                            )}
                          </div> */}
                        </div>

                        {/* Other content */}
                      </Card.Body>
                    </Card>
                  </Col>
                ))
              )}
            </InfiniteScroll>
          </Col>

         
        
        </>
      <Modal
                                                        size="md"
                                                        className="fade"
                                                        id="post-modal"
                                                        onHide={handleCloseDelete}
                                                        show={showDelete}
                                                        centered
                                                        style={{ marginTop: "100px", maxHeight: "80vh" }}
                                                      >
                                                        <Modal.Header className="d-flex justify-content-between">
                                                          <Modal.Title id="post-modalLabel">{t('delete_post')}</Modal.Title>
                                                          <Link to="#" className="lh-1" onClick={handleCloseDelete}>
                                                            <span className="material-symbols-outlined">close</span>
                                                          </Link>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                          <div
                                                            className="d-flex align-items-center"
                                                            style={{ fontSize: "16px" }}
                                                          >
                                                            <p>
                                                              {t('delete_confirm_event')}
                                                            </p>
                                                          </div>
                                                          <button
                                                            type="submit"
                                                            className="btn btn-primary d-block w-100 mt-0"
                                                            onClick={handleDeletePost}
                                                          >
                                                            {t('delete')}       </button>
                                                        </Modal.Body>
                                                      </Modal>
  </>
  );
};

export default EventProfile;
